const selectors = {
  container: '.js-contextMenu',
  toggle: '.js-contextMenuToggle',
  content: '.js-contextMenuContent',
};

export default class ContextMenu {

  private toggleButton: HTMLButtonElement;
  private contentTemplate: HTMLTemplateElement;
  private contentElement?: HTMLElement;

  constructor(private container: HTMLElement) {
    this.toggleButton = this.container.querySelector(selectors.toggle) as HTMLButtonElement;
    this.contentTemplate = this.container.querySelector(selectors.content) as HTMLTemplateElement;
    this.bindEvents();
  }

  static init(container: HTMLElement): ContextMenu {
    return new ContextMenu(container);
  }

  static initAll(): void {
    const contextMenus = document.querySelectorAll(selectors.container);
    contextMenus.forEach((contextMenu) => ContextMenu.init(contextMenu as HTMLElement));
  }

  private bindEvents(): void {
    this.toggleButton.addEventListener('click', () => {
      if (this.contentElement) {
        this.hideMenu();
      } else {
        this.showMenu();
      }
    });

    document.addEventListener('click', (event) => {
      if (this.contentElement && !this.contentElement.contains(event.target as Node) && !this.toggleButton.contains(event.target as Node)) {
        this.hideMenu();
      }
    });
  }

  showMenu(): void {
    this.contentElement = document.createElement('div');
    this.contentElement.classList.add('context-menu-content');
    this.contentElement.append(this.contentTemplate.content.cloneNode(true));
    document.body.appendChild(this.contentElement);

    const coords = this.getToggleButtonCoords();
    this.contentElement.style.top = `${coords.bottom + 1}px`;
    this.contentElement.style.left = `${coords.left}px`;

    // If the menu goes outside the body, right-align it to the button instead
    if (!this.isInsideBody(this.contentElement)) {
      this.contentElement.style.left = `${coords.right - this.contentElement.offsetWidth}px`;
    }

    this.contentElement.style.visibility = 'visible';
  }

  hideMenu(): void {
    this.contentElement.remove();
    this.contentElement = undefined;
  }

  private getToggleButtonCoords(): { top: number, left: number, bottom: number, right: number } {
    const rect = this.toggleButton.getBoundingClientRect();

    const { body } = document;
    const docEl = document.documentElement;

    const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

    const clientTop = docEl.clientTop || body.clientTop || 0;
    const clientLeft = docEl.clientLeft || body.clientLeft || 0;

    const top = +rect.top + scrollTop - clientTop;
    const bottom = +rect.bottom + scrollTop - clientTop;
    const left = +rect.left + scrollLeft - clientLeft;
    const right = +rect.right + scrollLeft - clientLeft;

    return {
      top: Math.round(top),
      left: Math.round(left),
      right: Math.round(right),
      bottom: Math.round(bottom),
    };
  }

  // eslint-disable-next-line class-methods-use-this
  private isInsideBody(el: HTMLElement): boolean {
    const rect = el.getBoundingClientRect();
    const bodyRect = document.body.getBoundingClientRect();
    return (
      rect.top >= bodyRect.top
      && rect.left >= bodyRect.left
      && rect.bottom <= bodyRect.bottom
      && rect.right <= bodyRect.right
    );
  }
}
